import { useBreakpoint } from '@/hooks/useBreakpoint';

type ContextBlockImageProps = {
  image: string;
  imageSize: string;
  hideOnMobile?: boolean;
};

const ContextBlockImage: React.FC<ContextBlockImageProps> = ({
  image,
  imageSize,
  hideOnMobile,
}) => {
  const { isMobile } = useBreakpoint();

  const style = image
    ? {
        backgroundImage: `url(${image})`,
        backgroundSize: imageSize,
      }
    : {};

  if (hideOnMobile && isMobile) {
    return null;
  }

  return <div className="context-block__image" style={style} />;
};

export default ContextBlockImage;
